export const links = {
    github: 'https://github.com/ZephyrCloudIO',
    discord: 'https://discord.gg/BdYXAMSaDr',
    doc: 'https://docs.zephyr-cloud.io',
    support: 'mailto:support@zephyr-cloud.io'
};
